import FullViewLoading from 'components/common/FullViewLoading';
import ScoreInterview from 'components/Interviews/ScoreInterview';
import { ScoreInterviewProvider } from 'components/Interviews/ScoreInterview/scoring.context';
import { useTopBar } from 'hooks/useTopBar';
import { useUser } from 'hooks/useUser';
import type { ComponentProps } from 'react';
import { useParams } from 'react-router';
import { isHubertAdminUser } from 'types/user.types';

export enum EScoringBuildSystem {
  Old = 'old',
  New = 'new',
}

interface ScoreInterviewPageProps extends ComponentProps<'div'> {
  scoringBuildSystem?: EScoringBuildSystem;
}

const ScoreInterviewPage = ({ scoringBuildSystem, ...props }: ScoreInterviewPageProps) => {
  const { interviewId } = useParams();
  const user = useUser();
  useTopBar({ stringTitle: `Scoring interview: ${interviewId}` });

  if (!interviewId) {
    return <FullViewLoading title="No interview id given." />;
  }

  if (!isHubertAdminUser(user)) {
    return <div>Erroneous user.</div>;
  }

  return (
    <div {...props}>
      <ScoreInterviewProvider interviewId={interviewId} user={user} scoringBuildSystem={scoringBuildSystem}>
        <ScoreInterview />
      </ScoreInterviewProvider>
    </div>
  );
};

export default ScoreInterviewPage;
